import { render, staticRenderFns } from "./dialogUpload.vue?vue&type=template&id=c2d01186&scoped=true&"
import script from "./dialogUpload.vue?vue&type=script&lang=ts&"
export * from "./dialogUpload.vue?vue&type=script&lang=ts&"
import style0 from "./dialogUpload.vue?vue&type=style&index=0&id=c2d01186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d01186",
  null
  
)

export default component.exports